import assessmentOpenButtonClick from '@hh.ru/analytics-js-events/build/career_platform/assessment_landing/assessment_open_button_click';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Button, Card } from '@hh.ru/magritte-ui';

import { getAssessmentSkillLink } from 'src/modules/externalLinks';
import { SkillCertShortDto } from 'src/types/skill';

import styles from './styles.less';

const TrlKeys = {
    button: 'career-platform.page-cert-landing.section.skills.item.button',
};

const Item: TranslatedComponent<SkillCertShortDto> = ({ id, name, iconLink, trls }) => {
    const handleClick = () => {
        assessmentOpenButtonClick({ skillId: id, skillName: name });
    };

    return (
        <Card
            padding={12}
            borderRadius={24}
            style="neutral"
            stretched
            verticalStretched
            actionCard
            Element="a"
            href={getAssessmentSkillLink(id)}
            target="_blank"
            rel="noreferrer noopener nofollow"
            onClick={handleClick}
        >
            <div className={styles.card}>
                <img src={iconLink} alt={name} className={styles.image} />
                <h3 className={styles.title}>{name}</h3>
                <div className={styles.button}>
                    <Button mode="primary" style="neutral" stretched onClick={handleClick} size="small">
                        {trls[TrlKeys.button]}
                    </Button>
                </div>
            </div>
        </Card>
    );
};

export default translation(Item);
